export const fadeInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 1, type: 'tween' } },
}

export const fadeInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 1, type: 'tween' } },
}

export const fadeInUp = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, type: 'tween' } },
}

export const fadeInDown = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, type: 'tween' } },
}

export const slideInLeft = {
    hidden: { opacity: 0, x: '-100vh' },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, type: 'tween' } },
    exit: { opacity: 0, x: '-100vh', transition: { duration: 0.5, type: 'tween' } },
}

export const slideInDown = {
    hidden: { opacity: 0, y: '-100vh' },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, type: 'tween' } },
    exit: { opacity: 0, y: '-100vh', transition: { duration: 0.5, type: 'tween' } },
}